import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

const StyledParagraph = styled(Typography)(
  ({ theme }) => `
    > span > a {
      font-size: inherit;
      line-height: inherit;
    }
  
     + p {
        margin: 12px 0;
      }
     + div img {
        margin-top: ${theme.DS_spacing(['md'])};
      }
     + ul, + ol {
      margin-top: ${theme.DS_spacing(['md'])};
      }
      
      + span:has(a) {
        margin-top: ${theme.DS_spacing(['md'])};
      }

    ${theme.breakpoints.up('md')} {
      + p {
      margin: 14px 0;
      }
      + div img{
      margin-top: ${theme.DS_spacing(['lg'])};
      }
      + ul, + ol,{
      margin-top: ${theme.DS_spacing(['md'])};
      }
      + span:has(a) {
        margin-top: ${theme.DS_spacing(['md'])};
      }
    }
  `,
);

export { StyledParagraph };
